import React, { useEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import Feedback from '../components/Sections/Feedback';
import SideBar from '../components/NavComponents/SideBar';
import TopNavigation from '../components/NavComponents/TopNavigation';
import Topic from '../components/SubSections/Topic';
import { EditImage } from '../components/SubSections/Topic/imageComponents/editImage';
import UserDashboard from '../components/SubSections/MeavanaDashboard';
import AddTopic from '../components/Sections/CreateNewTopic';
import EditCreatedTopic from '../components/Sections/CreateNewTopic/editCreatedTopic';
import DiscoverTopics from '../components/Sections/Discover/DiscoverTopics';
import User from '../components/SubSections/User';
import MainDashboard from '../components/Sections/MainDashboard';
import EditImagesOrder from '../components/SubSections/Topic/imageComponents/editImagesReorder';
import EditUser from '../components/SubSections/User/editUser';
import {
	AcceptTermsAction,
	LogoutAction,
	RejectTermsAction
} from '../redux/actions/authAction';
import { useDispatch } from 'react-redux';
import { globalEnv } from '../config/baseConfig';
import { useTypedSelector } from '../hooks/useTypeSelector';
import axiosInstance from '../config/axiosInstance';
import { QueryClient, QueryClientProvider, useMutation } from 'react-query';
import { setWindowDimensionsAction } from '../redux/actions/globalAction';

function Main() {
	const [dimensions, setDimensions] = useState({
		width: window.innerWidth,
		height: window.innerHeight
	});
	const dispatch = useDispatch();
	useEffect(() => {
		function handleResize() {
			dispatch(
				setWindowDimensionsAction({
					width: window.innerWidth,
					height: window.innerHeight
				})
			);
		}
		window.addEventListener('resize', handleResize);
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	const { acceptedTerms } = useTypedSelector((state) => state.auth);
	const queryClient = new QueryClient();
	return (
		<QueryClientProvider client={queryClient}>
			<div>
				<SideBar />
				<TopNavigation />

				<div className="h-screen w-full bg-base-bg-light dark:bg-base-bg-dark text-primary-text-light transition-all duration-500">
					<Routes>
						<Route path="/main-dashboard" element={<MainDashboard />} />
						<Route path="/documents" element={<DiscoverTopics />} />
						<Route path="/add-topic" element={<AddTopic />} />
						<Route path="/feedback" element={<Feedback />} />
						<Route path="/settings" element={<Feedback />} />
						<Route path="/user/:id" element={<User />} />
						<Route path="/user/:id/edit" element={<EditUser />} />
						<Route path="/topic/:id" element={<Topic />} />
						<Route
							path="/topic/:id/edit-images"
							element={<EditCreatedTopic />}
						/>
						<Route
							path="/topic/:topicId/reorder-images"
							element={<EditImagesOrder />}
						/>
						<Route path="/dashboard/:id" element={<UserDashboard />} />
						<Route
							path="/topic/:topicId/image/:imageId"
							element={<EditImage isForPhone={false} />}
						/>
						<Route
							path="/topic/:topicId/phone-image/:imageId"
							element={<EditImage isForPhone={true} />}
						/>
					</Routes>
				</div>
				{acceptedTerms || <Terms />}
			</div>
		</QueryClientProvider>
	);
}

const Terms = () => {
	const { ACCESS_TOKEN } = useTypedSelector((state) => state.auth);
	const dispatch = useDispatch();

	const acceptTermsReq = async () => {
		const config = {
			headers: {
				Authorization: 'Bearer ' + ACCESS_TOKEN
			}
		};
		const { data: response } = await axiosInstance().put(
			globalEnv.BASE_URL + '/editor/accept-terms',
			config
		);
		return response;
	};

	const acceptTerms = useMutation(acceptTermsReq, {
		onMutate: () => dispatch(AcceptTermsAction()),
		onError: () => {
			RejectTermsAction();
		}
	});

	return (
		<div
			className="fixed w-[90%] ml-9 h-2/3 mid:h-3/6 avgHeight:h-1/3 rounded-t-3xl
					   left-[50%] translate-x-[-50%] bottom-0"
		>
			<div className="absolute w-full h-full  backdrop-blur-2xl dark:bg-black/60 bg-gray-400" />
			<div className="absolute z-20 flex flex-col justify-center left-[50%] translate-x-[-50%] mt-8 bottom-0 mid:bottom-10">
				<h3 className="short:text-xl avgHeight:text-2xl tall:text-4xl text-center font-bold mb-2">
					Terms & Conditons
				</h3>
				<h3 className="avgHeight:text-md tall:text-lg">
					Before you start using the editor portal, you have to agree on
					Meavana's Terms & conditons.
				</h3>

				<a
					href={`/Terms_&_Conditions.html`}
					target="_blank"
					className="btn btn-outline btn-sm btn-primary mt-3 w-1/2 self-center"
					type="button"
					style={{ transition: 'all .15s ease' }}
				>
					Read the Terms & Conditions
				</a>

				<div className="flex flex-row justify-center mt-6">
					<button
						className={`btn btn-outline btn-sm mr-3 btn-error
						}`}
						type="button"
						style={{ transition: 'all .15s ease' }}
						onClick={() => dispatch(LogoutAction())}
					>
						Decline
					</button>
					<button
						className={`btn btn-outline btn-sm btn-accent mr-3
						}`}
						type="button"
						style={{ transition: 'all .15s ease' }}
						onClick={() => acceptTerms.mutate()}
					>
						Accept
					</button>
				</div>
			</div>
		</div>
	);
};

export default Main;
